'use strict';

/* TODO:

Implement with live-chat CTAs as well, model it after dealerSite,
where really it's just a dealer search modal
These are all well used only in offer-details-ajax
Use elsewhere and modify accordingly
*/

define('features/ctas/index',[
  './compare.cta',
  './dealer.site.cta',
  './raq.cta',
  './inventory.cta',
  './deal.builder.cta',
  './offers.cta'
], function (
  compare,
  dealerSite,
  raq,
  inventory,
  dealBuilder,
  offers
) {
  return {
    compare: compare,
    dealerSite: dealerSite,
    raq: raq,
    inventory: inventory,
    dealBuilder: dealBuilder,
    offers: offers
  };
});

